module.exports = __webpack_public_path__ + "img/4-4.ab55a0af.png";